import type { SelectProps } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';

type PySelectInputProps = SelectProps & {
  label: string;
  id: string;
  labelId: string;
  placeholder?: string;
  error?: boolean;
};

const placeholderStyle = {
  color: 'currentColor',
  opacity: 0.35,
};

const PySelectInput = ({ children, id, label, labelId, placeholder, error = false, ...otherProps }: PySelectInputProps) => {
  const theme = useTheme();

  return (
    <>
      <InputLabel id={`${id}`} shrink={true} error={error}>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        size="small"
        MenuProps={{ disableScrollLock: true }}
        input={
          <OutlinedInput
            label={label}
            notched={true}
            error={error}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: error ? theme.palette.error.main : undefined,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: error ? theme.palette.error.main : undefined,
              },
            }}
          />
        }
        fullWidth
        error={error}
        sx={{
          '& .MuiSelect-select': {
            paddingLeft: 1,
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
            borderWidth: '1px',
          },
        }}
        value={otherProps.value ?? ''}
        {...otherProps}
        displayEmpty
      >
        {placeholder && (
          <MenuItem disabled value="">
            <div style={placeholderStyle}>{placeholder}</div>
          </MenuItem>
        )}
        {children}
      </Select>
    </>
  );
};

export default PySelectInput;
